import React, { createContext, useContext, useReducer } from "react";
import axios from "axios";
export const StateContext = createContext();
export const StateProvider = ({ reducer, initialState, children }) => (
  <StateContext.Provider value={useReducer(reducer, initialState)}>
    {children}
  </StateContext.Provider>
);
export const useStateValue = () => useContext(StateContext);
// const Context = React.createContext({ authenticated: false });

export const registerToken = () => {
  const code = {
    grant_type: "refresh_token",
    refresh_token: localStorage.getItem("refresh_token"),
  };
  axios({
    method: "post",
    url: "fx-auth-server/oauth/token",
    data: code,
  }).then((response) => {
    console.log(response);
    if (response.data.access_token) {
      localStorage.setItem("token", response.data.access_token);
      localStorage.setItem("role", response.data.role);
      localStorage.setItem(
        "customerId",
        response.data.customerId ? response.data.customerId : -1
      );
      localStorage.setItem("tokenTime", Date.now());
      localStorage.setItem("view_as_client", response.data.view_as_client);
      localStorage.setItem(
        "readonly_customer",
        response.data.readonly_customer
      );
      localStorage.setItem("refresh_token", response.data.refresh_token);
      let status = "prospect";
      if (response.data.view_as_client) status = "view_as_client";
      else {
        if (response.data.is_user_admin) {
          status = "admin";
        } else if (response.data.prospectUser) {
          if (response.data.customerId) status = "registered";
          else status = "prospect";
        } else status = "approved";
      }
      localStorage.setItem("status", status);
    }
  });
};

export const refreshToken = () => {
  //clearInterval(tokenCheck);
  if (!window.tokenCheck) {
    let requestPending = false;
    window.tokenCheck = setInterval(() => {
      if (localStorage.getItem("refresh_token")) {
        const time =
          (Date.now() - localStorage.getItem("tokenTime")) / (1000 * 60);
        if (time > 4 && !requestPending) {
          requestPending = true;
          const code = {
            grant_type: "refresh_token",
            refresh_token: localStorage.getItem("refresh_token"),
          };
          axios({
            method: "post",
            url: "fx-auth-server/oauth/token",
            data: code,
          }).then((response) => {
            // console.log(response);
            if (response.data.access_token) {
              localStorage.setItem("token", response.data.access_token);
              localStorage.setItem(
                "customerId",
                response.data.customerId ? response.data.customerId : -1
              );
              localStorage.setItem("role", response.data.role);
              localStorage.setItem("tokenTime", Date.now());
              localStorage.setItem(
                "view_as_client",
                response.data.view_as_client
              );
              localStorage.setItem(
                "readonly_customer",
                response.data.readonly_customer
              );
              localStorage.setItem(
                "refresh_token",
                response.data.refresh_token
              );
              let status = "prospect";
              if (response.data.view_as_client) status = "view_as_client";
              else {
                if (response.data.is_user_admin) {
                  status = "admin";
                } else if (response.data.prospectUser) {
                  if (response.data.customerId) status = "registered";
                  else status = "prospect";
                } else status = "approved";
              }
              localStorage.setItem("status", status);
              requestPending = false;
            }
          });
        }
      }
    }, 5000);
  }
};

export const parseCurrency = (amount) => {
  if (amount && isNaN(amount) && amount.indexOf(",") !== -1) {
    let newAmount = "";
    let amountArr = amount.split(",");
    for (var k = 0; k < amountArr.length; k++) {
      // Trim the excess whitespace.
      amountArr[k] = amountArr[k].replace(/^\s*/, "").replace(/\s*$/, "");
      // Add additional code here, such as:
      newAmount = newAmount.concat(amountArr[k]);
    }
    amount = newAmount;
  }
  return amount;
};
export const formatMoney = (
  amount,
  decimalCount = 2,
  decimal = ".",
  thousands = ","
) => {
  try {
    decimalCount = Math.abs(decimalCount);
    decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

    const negativeSign = amount < 0 ? "-" : "";

    let i = parseInt(
      (amount = Math.abs(Number(amount) || 0).toFixed(decimalCount))
    ).toString();
    let j = i.length > 3 ? i.length % 3 : 0;

    return (
      negativeSign +
      (j ? i.substr(0, j) + thousands : "") +
      i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) +
      (decimalCount
        ? decimal +
          Math.abs(amount - i)
            .toFixed(decimalCount)
            .slice(2)
        : "")
    );
  } catch (e) {
    // console.log(e);
  }
};

export const formatDate = (dateObj) => {
  if (dateObj === null || dateObj === "") return null;

  var monthNames = [
    "JAN",
    "FEB",
    "MAR",
    "APR",
    "MAY",
    "JUN",
    "JUL",
    "AUG",
    "SEP",
    "OCT",
    "NOV",
    "DEC",
  ];

  var date = new Date(dateObj);
  date =
    date.getDate() +
    " " +
    monthNames[date.getMonth()] +
    " " +
    date.getFullYear();
  return date;
};
export const formateReportDate = (weekDate) => {
  if (weekDate === null || weekDate === "") return null;

  let dateObj = new Date(weekDate);

  var month =
    (dateObj.getMonth() + 1 < 10 ? "0" : "") + (dateObj.getMonth() + 1);
  var date = (dateObj.getDate() < 10 ? "0" : "") + dateObj.getDate();
  return date + "-" + month + "-" + dateObj.getFullYear();
};

export const parseDate = (weekDate) => {
  if (weekDate === null || weekDate === "") return null;

  let dateObj = new Date(weekDate);

  var month =
    (dateObj.getMonth() + 1 < 10 ? "0" : "") + (dateObj.getMonth() + 1);
  var date = (dateObj.getDate() < 10 ? "0" : "") + dateObj.getDate();
  return dateObj.getFullYear() + "-" + month + "-" + date;
};
export const parseDateTime = (weekDate) => {
  if (weekDate === null || weekDate === "") return null;

  let dateObj = new Date(weekDate);

  var month =
    (dateObj.getMonth() + 1 < 10 ? "0" : "") + (dateObj.getMonth() + 1);
  var date = (dateObj.getDate() < 10 ? "0" : "") + dateObj.getDate();
  var today = new Date();
  var min = today.getMinutes();
  if (min < 10) {
    min = "0" + min;
  }
  var sec = today.getSeconds();
  if (sec < 10) {
    sec = "0" + sec;
  }
  var time = today.getHours() + ":" + min + ":" + sec;

  return dateObj.getFullYear() + "-" + month + "-" + date + " " + time;
};

export const shortenDealId = (dealId) => {
  let newDealId = dealId;
  let index = dealId.lastIndexOf("-");
  if (index !== -1) {
    newDealId = dealId.substring(index + 1, dealId.length);
  }
  return newDealId;
};
export const sortArray = (arr, key, sortByAscending, dataType) => {
  let data =
    dataType === "string"
      ? sortByString(arr, key, sortByAscending)
      : dataType === "date"
      ? sortByDate(arr, key, sortByAscending)
      : dataType === "number"
      ? sortByNumber(arr, key, sortByAscending)
      : arr;
  return data;
};
export const sortByNumber = (arr, key, ascending) => {
  arr.sort((a, b) => {
    if (parseFloat(a[key]) < parseFloat(b[key])) {
      return ascending ? -1 : 1;
    } else {
      return ascending ? 1 : -1;
    }
  });
  return arr;
};
export const sortByString = (arr, key, ascending) => {
  arr.sort((a, b) => {
    if (a[key] < b[key]) {
      return ascending ? -1 : 1;
    } else {
      return ascending ? 1 : -1;
    }
  });
  return arr;
};
export const sortByDate = (arr, key, ascending) => {
  arr.sort((a, b) => {
    if (ascending) {
      return new Date(a[key]).getTime() - new Date(b[key]).getTime();
    } else {
      return new Date(b[key]).getTime() - new Date(a[key]).getTime();
    }
  });
  return arr;
};
export const formatErrString = (myJSON) => {
  // console.log(myJSON);
  var myJSONString = JSON.stringify(myJSON);
  // console.log(myJSONString);
  var myEscapedJSONString = myJSONString
    .replace(/\\n/g, "\\n")
    .replace(/\\'/g, "\\'")
    .replace(/\\"/g, '\\"')
    .replace(/\\&/g, "\\&")
    .replace(/\\r/g, "\\r")
    .replace(/\\t/g, "\\t")
    .replace(/\\b/g, "\\b")
    .replace(/\\f/g, "\\f");
  // console.log(myEscapedJSONString);
  return JSON.parse(myEscapedJSONString);
};

export const SearchTable = (tableData, keys, searchParam) => {
  let filteredData = [];
  if (tableData && tableData.length > 0) {
    filteredData = tableData.filter((row) => {
      let isExists = false;
      keys &&
        keys.forEach((key) => {
          if (typeof row[key] === "string") {
            isExists =
              isExists ||
              row[key].toLowerCase().includes(searchParam.toLowerCase());
          }
        });
      return isExists;
    });
  }
  return filteredData;
};
export const formatReportDate = (item) => {
  let dd = new Date();
  if (item) {
    // if (typeof item === "object") {
    //   return formatDate(item);
    // } else {
    console.log(new Date(item));
    return new Date(item);

    // const [year, month, day] = item.split("-");
    // const date = day + "-" + month + "-" + year;
    // return date;
    // }
  } else return "";
};
export const formatReportMoney = (item) => {
  // console.log(typeof item, item);
  let value = Number(item);
  // if (Number(value) < 0) {
  //   value = "-" + Math.abs(Number(value));
  // }
  // console.log("TYPE -  ", typeof value, item, value);
  return value ? value : "0.00";
};
// export { Context };

export const toCamelCase = (str) => {
  return str
      ?.replace(/[_-]/g, ' ')
      ?.split(' ')
      ?.map((word) => 
        word?.charAt(0)?.toUpperCase() + word?.slice(1)?.toLowerCase()
      )
      ?.join(' ');
};
export const formatAmount = (amount) => {
  if(!amount){
    return '₹ 0';
  }
  return `₹${new Intl.NumberFormat().format(amount)}`;
};

export const formatTimestamp = (timestamp) => {
  const date = new Date(timestamp);
  
  // Format options
  const options = { 
    year: "numeric", 
    month: "long", 
    day: "numeric", 
    hour: "2-digit", 
    minute: "2-digit", 
    hour12: true 
  };

  return date.toLocaleString("en-US", options);
};

export const parseDateMDY = (weekDate) => {
  if (weekDate === null || weekDate === "" || !weekDate) return null;

  let dateObj = new Date(weekDate);

  var month =
    (dateObj.getMonth() + 1 < 10 ? "0" : "") + (dateObj.getMonth() + 1);
  var date = (dateObj.getDate() < 10 ? "0" : "") + dateObj.getDate();
  return  date + "-" + month + "-" + dateObj.getFullYear() ;
};

export const formatTime = (seconds) => {
  const m = String(Math.floor(seconds / 60)).padStart(2, '0');
  const s = String(seconds % 60).padStart(2, '0');
  return `${m}:${s}`;
};

export const parseAndSetFlag = (flag) => {
  const parsedFlag = typeof flag === "boolean" ? flag : flag === "true";
 return parsedFlag;
};

// utils.js
export const generateRandomNumber = (n) => {
  if (typeof n !== 'number' || n <= 0 || !Number.isInteger(n)) {
    throw new Error('Please provide a positive integer.');
  }

  const min = Math.pow(10, n - 1);
  const max = Math.pow(10, n) - 1;

  return Math.floor(Math.random() * (max - min + 1)) + min;
}


  export const isEmpty = (value) =>
  value === null || value === undefined || value === "";


  export const removeSpecialCharFileName = (fileName) => {
  return fileName.replace(/[^a-zA-Z0-9.\-_]/g, "");
};

export const normalizeName = (name = "") =>
  name
    .replace(/^(mr|mrs|miss|ms)\.?\s+/i, "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, " ");

export const isMaskedBankAccount = (accountNo = "") => {
  return /^[*Xx#]+\d+$/.test(String(accountNo));
};

export const parseTimeDate = (dateString) => {
  if (!dateString) return "";

  const date = new Date(dateString);

  return date.toLocaleString("en-IN", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  });
};

export const getDaysIncludingTodayAndMaturity = (maturityDate, type) => {
  const start = new Date();
  const end = new Date(maturityDate);

  // Remove time portion
  start.setHours(0, 0, 0, 0);
  end.setHours(0, 0, 0, 0);

  const diffTime = end.getTime() - start.getTime();
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

  // Include both today and maturity date
  const totalDays = diffDays + 1;

  if (type === "DAYS") {
    return totalDays;
  }

  if (type === "MONTH") {
    return Math.ceil(totalDays / 30);
  }

  return totalDays;
}

export const getDeviceType = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  if (/android/i.test(userAgent)) {
    return "android";
  }

  if (/iPad|iPhone|iPod/i.test(userAgent)) {
    return "ios";
  }

  return "other";
};

export const isValidAlphabetValue = (value) => {
  if (!value || typeof value !== "string") {
    return false;
  }
  return /^[A-Za-z\s]+$/.test(value.trim());
};

export const isValidPincode = (value) => {
  return /^\d{6}$/.test(value?.toString().trim());
};

export const isValidRequiredValue = (value) => {
  return value !== undefined && value !== null && value.toString().trim() !== "";
};

export const textFormat = (text) => {
 const abc =  text?.toLowerCase()
  .split(' ')
  .map((s) => s?.charAt(0).toUpperCase() + s.substring(1))
  .join(' ');
  return abc;
}

 export const removeUnderscoresAndCapitalize = (str) => {
  const words = str?.split('_');
  const capitalizedWords = words?.map(word => word?.charAt(0)?.toUpperCase() + word?.slice(1));
  const result = capitalizedWords?.join(' ');
  return result;
};